import { JourneyDataModel } from '../../../../../services/redux/features/journeyData.slice';
import { CompanyDetailsFormModel_OB_OL } from './formModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const requestMapper = (values: CompanyDetailsFormModel_OB_OL): Partial<JourneyDataModel> => {
  return {};
};
